export default function assert(condition,message){if(!condition)throw new Error("Assertion failed. "+message)}
//# sourceMappingURL=assert.js.map


//////////////////
// WEBPACK FOOTER
// ./~/math.gl/dist-es6/lib/assert.js
// module id = 152
// module chunks = 0